module.exports = __webpack_public_path__ + "static/media/black-rectangle-803.a11b70bd.svg";